/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * CRITICAL — po terminie albo auto unieruchomione. WARNING — trzeba działać. INFO — brak danych.
 */

export const CarAttentionSeverityDto = {
    Critical: 'CRITICAL',
    Warning: 'WARNING',
    Info: 'INFO',
} as const;

export type CarAttentionSeverityDto = typeof CarAttentionSeverityDto[keyof typeof CarAttentionSeverityDto];



